import { render, staticRenderFns } from "./ManagerGetStarted.vue?vue&type=template&id=b61cd976&"
import script from "./ManagerGetStarted.vue?vue&type=script&lang=js&"
export * from "./ManagerGetStarted.vue?vue&type=script&lang=js&"
import style0 from "./ManagerGetStarted.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports